function inputRipple() {
	return {
		restrict: "C",
		link(scope, element) {
			const target = angular.element(
				element[0].querySelectorAll(".form-control")
			);

			target.on("focus", onFocus);
			target.on("blur", onBlur);

			scope.$on("$destroy", () => {
				element.off("focus", onFocus);
				element.off("blur", onBlur);
			});

			function onBlur() {
				const p = closestByClass(target, "form-group");

				if(p && p.hasClass("fg-float")) {
					if(!target.val()) {
						element.removeClass("fg-toggled");
					}
				} else {
					element.removeClass("fg-toggled");
				}
			}

			function onFocus() {
				element.addClass("fg-toggled");
			}
		}
	};
}

function closestByClass(el, className) {
	while(el) {
		if(angular.element(el).hasClass(className)) {
			return el;
		}
		el = el.parentNode;
	}
	return null;
}

export default angular
	.module("vesl.behaviors.input-ripple", [])
	.directive("fgLine", inputRipple).name;
